import { render, staticRenderFns } from "./CopilotAnprThumbnail.vue?vue&type=template&id=1b2eb94e"
import script from "./CopilotAnprThumbnail.vue?vue&type=script&lang=ts"
export * from "./CopilotAnprThumbnail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports